export default {
  Id: '',
  Name: '',
  Slug: '',
  Avatar: '',
};
